export const numberFormatting = (value, decimal) =>
  Number(value.toFixed(decimal));
